export default function () {

	const col = document.querySelectorAll( '.js-slideTiles_col' );

	col.forEach( function ( element ) {

		const toggle = element.querySelector( '.js-slideTiles_toggle' );

		element.addEventListener( 'mouseover', function () {

			this.classList.add( 'open-hover' );

		}, false );

		element.addEventListener( 'mouseleave', function () {

			this.classList.remove( 'open-hover' );

		}, false );

		/**
		 *
		 */
		toggle.onclick = function () {

			element.classList.toggle( 'open-click' );

		}

	} );

}
